import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Pagination from '../../../components/Pagination';
import Loader from '../../../components/Loader';
import EditableTable from "./PageHeaderTable";
import Modal from "../../../components/Modal"
import ChangeLog from "../../../components/ChangeLog";
import { alertSuccess } from "../../../components/Alert";
import Swal from "sweetalert2";
import api from "../../../auth/api";
import { updatePageHeaderData, fetchPageHeaderData } from "../../../slices/panelSlice/pageHeaderSlice";
import AddPageHeader from "./AddPageHeader";
import { fetchLanguageList } from "../../../slices/panelSlice/languageSlice";

 

function PageHeader({editable}) {
  const dispatch = useDispatch();
  const { pageHeaderData, status, error } = useSelector((state) => state.pageHeader);
    const language = useSelector((state) => state.language);
  
  const [currentPage, setCurrentPage] = useState(1);
  const [editRowId, setEditRowId] = useState(null);
  const [editedData, setEditedData] = useState({});
  
  const itemsPerPage = 10;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = Array.isArray(pageHeaderData?.result) ? pageHeaderData?.result?.slice(indexOfFirstItem, indexOfLastItem) : [];
  const totalPages = Array.isArray(pageHeaderData?.result) ? Math.ceil(pageHeaderData?.result?.length / itemsPerPage) : 0;
  const headers = pageHeaderData?.result?.length > 0 ? Object.keys(pageHeaderData.result[0]).filter((key) => key !== 'id') : [];
  const editableFields = ['title','status','pageNo']; // Define editable fields

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentLog,setCurrentLog] = useState([]);
  const [addPageDis, setAddPageDis] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const { optionList } = useSelector((state) => state.option);



  useEffect(() => {
    dispatch(fetchPageHeaderData());
      if(language.status ==='idle'){
        dispatch(fetchLanguageList())
      }
  }, [dispatch]);

  // if (status === "loading") {
  //   return (
  //     <div className="pt-12">
  //       <Loader />
  //     </div>
  //   );
  // }

  // if (status === "failed") {
  //   return <div>Error: {error}</div>;
  // }

  const handleEdit = (rowId) => {
    setEditRowId(rowId);
    const rowData = pageHeaderData?.result?.find((user) => user.id === rowId);
    setEditedData(rowData);
  };


  const handleSave = async () => {
    const { id, title, status, pageNo} = editedData;
    const updatedData = { id, title, status, pageNo };
    console.log(updatedData)
    const resp = await dispatch(updatePageHeaderData(updatedData));
    if (!resp.error) {
      setEditRowId(null);
      dispatch(fetchPageHeaderData());
    }
  };

  const handleCancel = () => {
    setEditRowId(null);
    setEditedData({});
  };

  const handleChange = (e, field,val) => {
      if(['status','active'].includes(field)){
        setEditedData((prev) => ({
          ...prev,
          [field]:!val,
        }));
      }else{
        setEditedData((prev) => ({
          ...prev,
          [field]:e.target.value,
        }));
      }
  };

  const handleLog = (id)=>{
    const logData = pageHeaderData.Change_Log.filter((f)=>f.id===id)[0]?.oldTrack;
    setCurrentLog(logData)
    openModal()
  }

  return (
    <div className="w-full flex items-center flex-col">
      <div className="max-w-full">
      <EditableTable
        headers={headers}
        rows={currentItems}
        editRowId={editRowId}
        editedData={editedData}
        handleEdit={handleEdit}
        handleSave={handleSave}
        handleCancel={handleCancel}
        handleChange={handleChange}
        handleLog={handleLog}
        editableFields={editableFields} // Pass editable fields
        optionList={optionList}
        languageList={language.data?.result}
        editable={editable}
      />
      </div>
      
      
      <div className="flex mt-4 items-center justify-between w-11/12">

<Pagination
  currentPage={currentPage}
  setCurrentPage={setCurrentPage}
  totalPages={totalPages}
/>

{editable && 
<button onClick={()=>setAddPageDis(true)} className="activeBtn text-sm text-white  py-1 px-2 rounded" >
            + Add Page Header
          </button>
}


    </div>

      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        title="Change Log"
        content={<ChangeLog data={currentLog}/>}
      />


<Modal
        isOpen={addPageDis}
        onClose={()=>setAddPageDis(false)}
        title="Add Page Header"
        content={<AddPageHeader/>}
      />



    </div>
  );
}

export default PageHeader;